import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { getClubExpenses, destroyClubExpense } from '../../../api/ClubExpensesAPI';
import AppPaginator from '../../AppPaginator';
import AppSearchBox from '../../AppSearchBox';
import PerPageBlock from '../../../components/common/PerPageBlock';
import { Can } from '../../../hooks/usePermissions';

const ClubExpensesList = () => {
    const navigate = useNavigate();
    const [expensesList, setExpensesList] = useState({ data: [], last_page: 0 });
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(15);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchTermCompleted, setSearchTermCompleted] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [triggerFetch, setTriggerFetch] = useState(false);

    // --- THIS IS THE CORRECTED LOGIC ---
    useEffect(() => {
        setIsLoading(true);
        const filters = { page: currentPage, per_page: perPage, search_term: searchTermCompleted };
        getClubExpenses(filters, (response) => {
            setIsLoading(false);
            if (response.expenses) {
                setExpensesList(response.expenses);
            }
        });
    }, [currentPage, perPage, searchTermCompleted, triggerFetch]);

    const handleAddClick = () => navigate('/club_portal/expenses/create');
    const handleEditClick = (id) => navigate(`/club_portal/expenses/edit/${id}`);
    const handleViewStatementClick = (id) => navigate(`/club_portal/expenses/statement/${id}`);

    const handleDeleteClick = (expense) => {
        Swal.fire({
            title: 'Are you sure?',
            html: `<p>You are about to delete the expense:</p><strong>${expense.description}</strong><p>This action cannot be undone.</p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                destroyClubExpense(expense, (response) => {
                    if (response.success) {
                        Swal.fire('Deleted!', 'The expense has been deleted.', 'success');
                        setTriggerFetch(prev => !prev);
                    } else {
                        Swal.fire('Error!', response?.response?.data?.message || 'Could not delete the expense.', 'error');
                    }
                });
            }
        });
    };

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div>
                    <h5>All Expenses</h5>
                    <small className="text-muted">Record and manage miscellaneous club costs.</small>
                </div>
                <div className="d-flex align-items-center">
                    <AppSearchBox searchTerm={searchTerm} setSearchTerm={setSearchTerm} setSearchTermCompleted={setSearchTermCompleted} />
                      <Can any={['create-club-expenses']}>
                    <button className="btn btn-primary ms-3 text-nowrap" onClick={handleAddClick}>
                        <i className="ti ti-plus me-2"></i> Add Expense
                    </button>
                    </Can>
                </div>
            </div>
            <div className="card-body">
                {isLoading ? (
                    <div className="text-center p-5"><div className="spinner-border"></div></div>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th>Description</th>
                                    <th>Account Head</th>
                                    <th>Date</th>
                                    <th className="text-end">Amount</th>
                                    <th className="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {expensesList.data.length > 0 ? expensesList.data.map(expense => (
                                    <tr key={expense.id}>
                                        <td>{expense.description}</td>
                                        <td>{expense.head_of_account.name}</td>
                                        <td>{expense.expense_date}</td>
                                        <td className="text-end">₹{expense.total_amount}</td>
                                        <td className="text-center">
                                            <button className="btn btn-outline-secondary btn-sm me-2" onClick={() => handleViewStatementClick(expense.id)}>View</button>
                                             <Can any={['edit-club-expenses']}>
                                            <button className="btn btn-outline-primary btn-sm me-2" onClick={() => handleEditClick(expense.id)}>Edit</button>
                                            </Can>
                                             <Can any={['delete-club-expenses']}>
                                            <button className="btn btn-outline-danger btn-sm" onClick={() => handleDeleteClick(expense)}>Delete</button>
                                            </Can>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="5" className="text-center">No expenses found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
                <div className="d-flex justify-content-between">
                    {expensesList.data.length > 0 &&
                        <PerPageBlock perPage={perPage} setPerPage={setPerPage} />
                    }
                    <AppPaginator totalPages={expensesList.last_page} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                </div>
            </div>
        </div>
    );
};

export default ClubExpensesList;